mutation MovementTravelerUpdate(
  $input: MovementTravelerUpdateInput!
  $id: UUID!
) {
  movementTravelerUpdate(input: $input) {
    boolean
    query {
      movementTravelerJourney(id: $id) {
        id
        __typename
        _rowTimestamp
        _isUpdatable
        _isDeletable
        phraseType
        headerTitle
        headerCityFromTo
        bodyArea1
      }
    }
  }
}
